export default {
      id: "ic-misc-link-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-link-usage",
      toString: function () {
        return this.url;
      }
    }